import React from "react";

export function FAQIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="st0" d="M345.293,131.536V99.417c0-30.758-24.924-55.691-55.692-55.691H55.691C24.924,43.726,0,68.659,0,99.417V273.8 c0,30.758,24.924,55.691,55.691,55.691h20.512l-16.674,83.354l114.068-83.354h21.383V218.482c0-47.938,39-86.946,86.948-86.946 H345.293z"></path>
            <path className="st0" d="M456.309,162.792H281.928c-30.767,0-55.692,24.933-55.692,55.691v125.118 c0,30.758,24.925,55.691,55.692,55.691h86.406l94.394,68.982l-13.797-68.982h7.378c30.758,0,55.691-24.933,55.691-55.691V218.482 C512,187.724,487.067,162.792,456.309,162.792z"></path>
        </svg>
    );
}